import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SpecificElementClass;
function SpecificElement() {
  if (SpecificElementClass === VOID) {
    class $ extends RecyclerViewAnchor() {
      constructor(index, align) {
        super();
        this.ydj_1 = index;
        this.zdj_1 = align;
      }
      toString() {
        return 'SpecificElement(index=' + this.ydj_1 + ', align=' + this.zdj_1.toString() + ')';
      }
      hashCode() {
        var result = this.ydj_1;
        result = imul(result, 31) + this.zdj_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SpecificElement()))
          return false;
        if (!(this.ydj_1 === other.ydj_1))
          return false;
        if (!this.zdj_1.equals(other.zdj_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SpecificElement');
    SpecificElementClass = $;
  }
  return SpecificElementClass;
}
var FuzzyIndexClass;
function FuzzyIndex() {
  if (FuzzyIndexClass === VOID) {
    class $ extends RecyclerViewAnchor() {
      constructor(index, ratioOfFocus) {
        super();
        this.adk_1 = index;
        this.bdk_1 = ratioOfFocus;
      }
      toString() {
        return 'FuzzyIndex(index=' + this.adk_1 + ', ratioOfFocus=' + this.bdk_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.adk_1);
        result = imul(result, 31) + getNumberHashCode(this.bdk_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FuzzyIndex()))
          return false;
        if (!equals(this.adk_1, other.adk_1))
          return false;
        if (!equals(this.bdk_1, other.bdk_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'FuzzyIndex');
    FuzzyIndexClass = $;
  }
  return FuzzyIndexClass;
}
var RecyclerViewAnchorClass;
function RecyclerViewAnchor() {
  if (RecyclerViewAnchorClass === VOID) {
    class $ {}
    initMetadataForClass($, 'RecyclerViewAnchor');
    RecyclerViewAnchorClass = $;
  }
  return RecyclerViewAnchorClass;
}
//region block: exports
export {
  FuzzyIndex as FuzzyIndex1f984se19g5yx,
  SpecificElement as SpecificElement1fm8kkyg4nw48,
};
//endregion

//# sourceMappingURL=RecyclerViewAnchor.mjs.map
